export { default } from '@views/CurriculumListPage'
